module.exports = __webpack_public_path__ + "static/media/archero-icon@2x.28dd4990.png";